<template>
  <!-- <vue-pivottable-ui
    :data="dataList"
    :rows="['HID']"
  >
  </vue-pivottable-ui> -->
  <vue-pivottable-ui
            :data="dataList"
            :rows="['HID']"
            :row-total="true"
            :col-total="true"
        >
        <template v-slot:colGroup>
          <colGroup :width="colGroupFirstWidth" ></colGroup>
          <colGroup></colGroup>
        </template>
        </vue-pivottable-ui>

</template>

<script>
import { VuePivottableUi } from 'vue-pivottable'
import 'vue-pivottable/dist/vue-pivottable.css'
import axios from "../../plugins/axios";
export default {
  components: {
    VuePivottableUi
  },
  data: () => ({
    dataList:'',
    colGroupFirstWidth: 250,
    colGroupFirstHeight: 50
  }),
  mounted(){
    this.getData();
  },
  methods:{
    async getData(){
       try {
        const res = await axios.get(`${process.env.VUE_APP_API_URL}/pivot/getData`);

          this.dataList = res.data.data;
          console.log(this.dataList)

      } catch (error) {
        console.log(error)
      }
    }
  }
}
</script>